import React from 'react';
import { IconSizes } from '../../../visuals/Icons/type';

interface IPictoProps {
  Component: React.ElementType;
  size?: IconSizes | undefined;
}

export const Picto: React.FC<IPictoProps> = ({ Component, size }) => {
  return (
    <Component
      className="picto tw-flex tw-items-center tw-grid-area-[picto]"
      size={size}
      aria-hidden={true}
    />
  );
};
